import React, { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Chip,
} from "@mui/material";
import { Cake, Edit, Add } from "@mui/icons-material";

const Events = () => {
  const [events, setEvents] = useState([
    { name: "Somya Pradhan", date: "01-Jan" },
    { name: "Sejal Gupta", date: "15-Jan" },
    { name: "Kajal Yadav", date: "24-Jan" },
    { name: "Vivek Pandit", date: "31-Jan" },
    { name: "Kirti Rajawat", date: "02-Feb" },
    { name: "Priya Dubey", date: "08-Feb" },
    { name: "Raveen Bhatnager", date: "12-Feb" },
    { name: "Vipul Sharma", date: "13-Feb" },
    { name: "Sanskrati Chauhan", date: "06-Mar" },
    { name: "Narendra Singh Kushwah", date: "24-Mar" },
    { name: "Shubhanshi Shrivastava", date: "04-May" },
    { name: "Neha Singh", date: "12-May" },
    { name: "Saloni Sharma", date: "01-Jun" },
    { name: "Geeta Gaire", date: "05-Jun" },
    { name: "Shivani Chauhan", date: "07-Jun" },
    { name: "Sweety Yadav", date: "06-Jul" },
    { name: "Satish Sir", date: "11-Jul" },
    { name: "Shefali Yadav", date: "15-Jul" },
    { name: "Sachin Savita", date: "28-Jul" },
    { name: "Aditya Gupta", date: "31-Jul" },
    { name: "Vanshika Chaturvedi", date: "14-Aug" },
    { name: "Krishna Samadhiya", date: "14-Aug" },
    { name: "Shibhansh Shrivastava", date: "15-Aug" },
    { name: "Sandhya Chauchan", date: "18-Aug" },
    { name: "Arti Tomar", date: "18-Aug" },
    { name: "Vikas S. Tomar", date: "19-Aug" },
    { name: "Rahul Singh Rajawat", date: "31-Aug" },
    { name: "Akash Baghel", date: "18-Sep" },
    { name: "Tanvi Rathore", date: "21-Sep" },
    { name: "Neha Surve", date: "22-Sep" },
    { name: "Anjali Goyal", date: "25-Sep" },
    { name: "Sakshi Gupta", date: "14-Oct" },
    { name: "Poonam Dixit", date: "25-Oct" },
    { name: "Varsha Chandwani", date: "25-Oct" },
    { name: "Sakshi Sijariya", date: "02-Nov" },
    { name: "Aman Dhanoliya", date: "06-Nov" },
    { name: "Monika Chauhan", date: "20-Nov" },
    { name: "Nikita Rajawat", date: "14-Nov" },
    { name: "Pooja Verma", date: "25-Nov" },
    { name: "Manav Jain", date: "17-Dec" },
    { name: "Angila Chandil", date: "21-Dec" },
  ]);

  const [open, setOpen] = useState(false);
  const [currentEvent, setCurrentEvent] = useState({ name: "", date: "" });
  const [editIndex, setEditIndex] = useState(null);

  const handleOpen = (event = { name: "", date: "" }, index = null) => {
    setCurrentEvent(event);
    setEditIndex(index);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentEvent({ name: "", date: "" });
    setEditIndex(null);
  };

  const handleSave = () => {
    if (editIndex !== null) {
      const updated = [...events];
      updated[editIndex] = currentEvent;
      setEvents(updated);
    } else {
      setEvents([...events, currentEvent]);
    }
    handleClose();
  };

  return (
    <Box p={3}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography
          variant="h5"
          sx={{
            fontWeight: "bold",
            background: "linear-gradient(135deg, #2563eb, #1e40af)",
            WebkitBackgroundClip: "text",
          }}
        >
          🎉 Employee Events & Birthdays
        </Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => handleOpen()}
          sx={{ borderRadius: "12px", textTransform: "none", fontWeight: "bold" }}
        >
          Add Event
        </Button>
      </Box>

      <Grid container spacing={3}>
        {events.map((event, index) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
            <Card
              sx={{
                height: 200, // Fixed height
                width: "100%", // Full width of grid item
                borderRadius: "18px",
                boxShadow: "0px 6px 16px rgba(0,0,0,0.12)",
                transition: "0.3s",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                alignItems: "center",
                "&:hover": {
                  transform: "translateY(-5px)",
                  boxShadow: "0px 8px 20px rgba(0,0,0,0.2)",
                },
              }}
            >
              <CardContent sx={{ textAlign: "center" }}>
                <Cake fontSize="large" color="secondary" />
                <Typography variant="h6" fontWeight="bold" mt={1}>
                  {event.name}
                </Typography>
                <Chip
                  label={event.date}
                  color="primary"
                  variant="outlined"
                  sx={{ mt: 1, fontWeight: "bold" }}
                />
                <Box mt={2}>
                  <IconButton
                    color="primary"
                    onClick={() => handleOpen(event, index)}
                  >
                    <Edit />
                  </IconButton>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Add/Edit Modal */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{editIndex !== null ? "Edit Event" : "Add Event"}</DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
          <TextField
            label="Name"
            fullWidth
            margin="dense"
            value={currentEvent.name}
            onChange={(e) =>
              setCurrentEvent({ ...currentEvent, name: e.target.value })
            }
          />
          <TextField
            label="Birth Date (e.g., 01-Jan)"
            fullWidth
            margin="dense"
            value={currentEvent.date}
            onChange={(e) =>
              setCurrentEvent({ ...currentEvent, date: e.target.value })
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Events;
